export default {
    name: "Hide",
    title: "Hide",
    icon: "mdi-eye-off-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            container: null,
        };
    },
};